import angular from 'angular';
import cmsACL from '../../ACL/ACLService';

/**
 * @memberOf cms.input.text
 * @property {object}   bindings.errors     Form errors object
 * @property {string}   bindings.model      Input value reference
 * @property {string}   bindings.title      Input title and/or placeholder
 * @property {function} bindings.onBlur     Function called on input blur event
 * @property {function} bindings.onChange   Function called on input change event
 */
let cmsInputMapAddress = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        onBlur: '&',
        onChange: '&',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@',
        placeholder: '@'
    },
    template: require('./mapAddress.html'),
    controller: function ($scope) {
        this.findAddress = () => {

            let geocoder = new google.maps.Geocoder();

            geocoder.geocode({address: this.model.textAddress}, (results, status) => {
                //this console log is necessary for testing why maps are not working
                console.log(status, google.maps.GeocoderStatus.OK);
                if (status === google.maps.GeocoderStatus.OK) {
                    let result = results.pop();

                    this.model.coordinates.lat = result.geometry.location.lat();
                    this.model.coordinates.lng = result.geometry.location.lng();
                    //this console log is necessary for testing why maps are not working
                    console.log(this.model.coordinates.lat, this.model.coordinates.lng, result.geometry.location.lat(), result.geometry.location.lng());
                    $scope.$emit('map-changed');
                }
            });
        };

        this.zoomInc = () => {
            if (this.model.zoom > 21) {
                return;
            }

            this.model.zoom++;
            $scope.$emit('map-changed');
        };

        this.zoomDec = () => {
            if (this.model.zoom < 1) {
                return;
            }

            this.model.zoom--;
            $scope.$emit('map-changed');
        }

    }
};

/**
 * Text control
 * @namespace cms.input.text
 */
export default angular.module('cms.input.map-address', [cmsACL]).component('cmsInputMapAddress', cmsInputMapAddress).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Controls/MapAddressControl/CmsInputMapAddress.js